import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { persistStore, persistReducer } from 'redux-persist'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import storage from 'redux-persist/lib/storage'
import thunk from 'redux-thunk'
import createSagaMiddleware from 'redux-saga'

import { Reducers } from './rootReducers'
import rootSaga from './rootSagas'

const persistConfig = {
  storage,
  key: 'rpg_ir@7367457',
  stateReconciler: autoMergeLevel2,
  whitelist: [
    'auth',
  ],
  // blacklist: [],
}

const sagaMiddleware = createSagaMiddleware()
const middlewares = [thunk, sagaMiddleware]

const persistedReducer = persistReducer(persistConfig, Reducers)
const store = createStore(
  persistedReducer,
  process.env.NODE_ENV === 'development'
    ? composeWithDevTools(applyMiddleware(...middlewares))
    : applyMiddleware(...middlewares),
)

const persistor = persistStore(store)
sagaMiddleware.run(rootSaga)

export { store, persistor }
